import { css, Theme } from '@emotion/react'
import {
  accordionClasses,
  accordionSummaryClasses,
  alpha,
  autocompleteClasses,
  buttonBaseClasses,
  formHelperTextClasses,
  outlinedInputClasses,
} from '@mui/material'
import { scaleBorderRadius } from 'theme/utils'

export const label = (theme: Theme) => css`
  font-weight: 400;
  color: ${theme.typographyColors.typographyThree};
`

export const tabs = (theme: Theme) => css`
  margin: ${theme.spacing(3, 0, 3)};
`

export const accordion = (theme: Theme) => css`
  margin: ${theme.spacing(2, 0, 0)};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 3.5)};
  box-shadow: 0px 2px 2px -1px ${alpha(theme.colors.typographyThree, 0.21)};

  &.${accordionClasses.expanded} {
    margin: ${theme.spacing(3, 0, 0)};

    :first-of-type {
      margin-top: ${theme.spacing(1.25)};
    }
  }

  .${buttonBaseClasses.focusVisible} {
    background-color: transparent;
  }

  :first-of-type {
    margin-top: ${theme.spacing(2)};
    border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 3.5)};
  }

  :last-of-type {
    border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 3.5)};
  }

  :before {
    display: none;
  }
`

export const accordionSummary = (theme: Theme) => css`
  & .${accordionSummaryClasses.content} {
    & .${accordionSummaryClasses.expanded} {
      margin: ${theme.spacing(1.5, 0)};
    }

    align-items: center;
    justify-content: space-between;
    cursor: default;
    gap: 10px;
  }

  .${accordionSummaryClasses.content}.${accordionSummaryClasses.expanded} {
    margin: ${theme.spacing(1.5, 0)};
  }

  &.${accordionSummaryClasses.focusVisible} {
    background: transparent;
  }
`

export const textWrapper = css`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const iconButton = css`
  &.${buttonBaseClasses.root} {
    height: 36px;
    width: 36px;
    min-width: 36px;
    padding: 0;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`

export const accordionError = (theme: Theme) => css`
  border: 1px solid ${theme.colors.red};
`

export const accordionDetails = css`
  padding: 0;

  .${formHelperTextClasses.root} {
    display: none;
  }
`

export const editor = css`
  .text-editor {
    border-radius: 0 0 14px 14px;
    margin: 0 -1px -1px;
  }
`

export const DATSelect = (theme: Theme) => css`
  .${buttonBaseClasses.root} {
    span {
      width: 100px;
      padding-right: 12px;
      padding-left: 12px;

      color: ${theme.colors.typographyThree};
    }
  }
  .chevron {
    display: none;
  }
`

export const DATSelectPopper = (theme: Theme) => css`
  width: 100px;

  & .${autocompleteClasses.paper} .${autocompleteClasses.option} {
    padding: ${theme.spacing(1)};

    svg {
      display: none;
    }
  }
`

export const numberInput = (value: string | null) => (theme: Theme) =>
  css`
    height: 44px;
    width: auto;

    .${outlinedInputClasses.root} {
      padding: ${theme.spacing(1.5)};
      height: 100%;
      width: ${!value || value.length < 3 ? '55px' : `calc(${value.length}ch + 24px)`};
    }

    .${formHelperTextClasses.root} {
      display: none;
    }
  `

export const iconChevron = (theme: Theme) => css`
  transition: all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut};
`

export const iconChevronOpen = css`
  transform: rotate(180deg);
`

export const addContentButton = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};
  width: 100%;
`
